import { Body1 } from "@fluentui/react-components";
import { PanelDrawer } from "../../../../../components/Panel/PanelDrawer";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { UsePanelRazonModeloSync } from "./UsePanelRazonModeloSync";

export const PanelRazonModeloSync=(props:IOpenPanel)=>{
   const {status,mensaje,loading,Sincronizar,reset} =UsePanelRazonModeloSync(props)
   return (
    <PanelDrawer isOpen={props.isOpen} textHeader={"Sincroniza de razones Modelos"} 
    status={status} mensaje={mensaje} loading={loading} onDismiss={reset}>
        <Body1>
        Sincronización finalizada
        </Body1>
    </PanelDrawer> 
   )
}